<div class="desktop-width-limiter overview-page page-padding">
  @if (!loading && !errorText && streappers.length > 0) {
  <div class="row overview-items">
    @for (streapper of streappers; track streapper) {
    <div
      class="col-xs-6 col-sm-6 col-md-6 col-lg-4 col-xl-4 col-xxl-2 overview-item"
    >
      <streapper-card [streapper]="streapper"></streapper-card>
    </div>
    }
  </div>
  } @if (loading) {
  <div class="loading">
    <mat-progress-spinner
      class="loading-spinner"
      [diameter]="250"
      mode="indeterminate"
      color="primary"
    >
    </mat-progress-spinner>
    <div class="loading-text"><h1>Laden...</h1></div>
  </div>
  }
</div>
